import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/3hYcyjs9g2WwdpGbRXLsUB/image.png', 'https://cdn.magicpatterns.com/uploads/85v7KTNd9QPYnAZPfzLmLb/PORTADA_1.png', 'https://cdn.magicpatterns.com/uploads/pEzrGg2KH3Qf693sVgqq2g/PORTADA_2.png'];
export function ProductCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % images.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  return <section className="bg-brand-dark pt-4 pb-12 px-5 overflow-hidden" data-id="element-264">
      <div className="max-w-xl mx-auto text-center" data-id="element-265">
        <h2 className="text-2xl md:text-3xl font-black text-white mb-6 flex items-center justify-center gap-2" data-id="element-266">
          📸 Mira el material por dentro
        </h2>

        <div className="flex items-center justify-between mb-6 text-blue-400/60 px-2" data-id="element-267">
          <button onClick={prev} className="p-2 hover:text-blue-400 transition-colors bg-white/5 rounded-lg border border-white/10" aria-label="Anterior" data-id="element-268">
            <ChevronLeft size={20} data-id="element-269" />
          </button>

          <span className="text-[10px] font-bold uppercase tracking-widest" data-id="element-270">
            Desliza para ver más
          </span>

          <div className="flex items-center gap-4" data-id="element-271">
            <button onClick={next} className="p-2 hover:text-blue-400 transition-colors bg-white/5 rounded-lg border border-white/10" aria-label="Siguiente" data-id="element-272">
              <ChevronRight size={20} data-id="element-273" />
            </button>
            <span className="text-xs font-bold tabular-nums text-gray-500" data-id="element-274">
              {currentIndex + 1} / {images.length}
            </span>
          </div>
        </div>

        <div className="relative aspect-[3/4] md:aspect-[4/5] overflow-hidden mb-8 mockup-glow rounded-2xl bg-white/5 border border-white/10" data-id="element-275">
          <AnimatePresence mode="wait" data-id="element-276">
            <motion.img key={currentIndex} src={images[currentIndex]} alt={`Vista del producto ${currentIndex + 1}`} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="w-full h-full object-contain" data-id="element-277" />
          </AnimatePresence>
        </div>

        <div className="flex justify-center gap-2" data-id="element-278">
          {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`h-1.5 rounded-full transition-all duration-300 ${idx === currentIndex ? 'w-8 bg-brand-yellow' : 'w-2 bg-gray-700'}`} aria-label={`Ir a imagen ${idx + 1}`} data-id="element-279" />)}
        </div>
      </div>
    </section>;
}